module.exports = __webpack_public_path__ + "img/feather-package.4556e280.svg";